// Reemplazo de @waju/vue-guard (abandonado en 0.0.1, pinned a vue@^2.6.11,
// basado en un componente funcional cuyo API desaparece en Vue 3).
// Acá solo necesitamos lo que la app realmente usa: <v-guard :permissions="[...]">
// y this.$permitsAny([...]) — nunca $permitsAll ni el router guard (meta.guard
// no se usa en ninguna ruta), asi que ese código no se porta.
//
// A diferencia del original, $permitsAny/$permitsAll leen el store en cada
// llamada en vez de cachear un snapshot en beforeCreate — eso evitaba que
// se actualizaran tras logout+login sin F5 (ver bug ya resuelto en los menus).
function isPermitted(userPermissions, required, all) {
  const needed = Array.isArray(required) ? required : String(required).trim().split(',');
  const has = new Set((userPermissions || []).map((p) => p.trim()));
  const matched = needed.filter((p) => has.has(p.trim()));
  return all ? matched.length === needed.length : matched.length > 0;
}

export default {
  install(Vue, { store }) {
    function getUserPermissions() {
      const authUser = store.state.authUser && store.state.authUser.authUser;
      if (authUser && Array.isArray(authUser.permissions)) {
        return authUser.permissions;
      }
      const cached = localStorage.getItem('permissions');
      return cached ? JSON.parse(cached) : [];
    }

    Vue.prototype.$permitsAny = function (permissions) {
      return isPermitted(getUserPermissions(), permissions, false);
    };
    Vue.prototype.$permitsAll = function (permissions) {
      return isPermitted(getUserPermissions(), permissions, true);
    };

    // functional: true porque varios usos envuelven varios nodos hermanos
    // (ej. dos <router-link> seguidos) sin un wrapper propio — Vue 2 solo
    // permite devolver un array de VNodes desde un componente funcional.
    // Al migrar a Vue 3 esto deja de ser necesario (todo componente puede
    // devolver fragments), así que este es el único punto a tocar entonces.
    Vue.component('v-guard', {
      functional: true,
      props: {
        permissions: {
          type: [Array, String],
          default: () => [],
        },
        all: {
          type: Boolean,
          default: false,
        },
      },
      render(h, { props, slots }) {
        if (isPermitted(getUserPermissions(), props.permissions, props.all)) {
          return slots().default;
        }
        return h();
      },
    });
  },
};
